/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize, tap } from 'rxjs';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { ProjectService } from './@shared/services/project.service';
import { Globals } from './gloabls';

@Component({
  selector: 'ngx-app',
  template: `
            <mat-progress-bar *ngIf="!isLoad" mode="buffer" class="p-loading-page-loder"></mat-progress-bar>
            <router-outlet *ngIf="isLoad"></router-outlet>
          `,
})
export class AppComponent implements OnInit {
  public isLoad:boolean=false;
  constructor(private _projectServices:ProjectService,private globals: Globals,public router: Router) {
  }

  ngOnInit(): void {
    if(!localStorage.getItem('token')){
      this.isLoad=true
      return;
    }
    this.getLoginUserInfo();
  }
  //on load user api
  public getLoginUserInfo(): void{
    this._projectServices.getUserProfile()
    .pipe(
      tap(res=>{
        this.globals.user=res;
      }),
      finalize(()=>this.isLoad=true)
    ).subscribe();
  }
}
